/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";

export const useForm = (initialForm = {}, formValidations = {}) => {
  const [formState, setFormState] = useState(initialForm);
  const [formValidation, setFormValidation] = useState({});

  useEffect(() => {
    createValidations();
  }, [formState]);

  const isFormValid = useMemo(() => {
    for (const formValue of Object.keys(formValidation)) {
      if (
        formValidation[formValue] !== null ||
        formValidation[formValue] === undefined
      )
        return false;
    }
    return true;
  }, [formValidation]);

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onResetForm = () => {
    setFormState(initialForm);
  };

  const createValidations = () => {
    const formCheckedValues = {};
    for (const formField of Object.keys(formValidations)) {
      const fn = formValidations[formField];
      formCheckedValues[`${formField}Valid`] = fn(formState[formField]);
    }
    setFormValidation(formCheckedValues);
  };

  return {
    ...formState,
    ...formValidation,
    formValidation,
    formState,
    isFormValid,
    onInputChange,
    onResetForm,
    setFormState,
  };
};
